// @ts-nocheck
/* eslint-disable */
/* tslint:disable */
/* prettier-ignore-start */
import React from "react";
import { classNames } from "@plasmicapp/react-web";

export type UploadSvgrepoComsvgIconProps = React.ComponentProps<"svg"> & {
  title?: string;
};

export function UploadSvgrepoComsvgIcon(props: UploadSvgrepoComsvgIconProps) {
  const { className, style, title, ...restProps } = props;
  return (
    <svg
      xmlns={"http://www.w3.org/2000/svg"}
      version={"1.1"}
      viewBox={"0 0 512 512"}
      height={"1em"}
      width={"1em"}
      style={{
        fill: "currentcolor",

        ...(style || {}),
      }}
      className={classNames("plasmic-default__svg", className)}
      {...restProps}
    >
      {title && <title>{title}</title>}

      <path
        d={
          "M153.7 171.5l81.9-88.1v265.3c0 11.3 9.1 20.4 20.4 20.4 11.3 0 20.4-9.1 20.4-20.4V83.4l81.9 88.1c7.7 8.3 20.6 8.7 28.9 1.1 8.3-7.7 8.7-20.6 1.1-28.9L271 17.5c-11.5-11.6-25.6-5.2-29.9 0L123.8 143.7c-7.7 8.3-7.2 21.2 1.1 28.9 8.2 7.6 21.1 7.2 28.8-1.1z"
        }
      ></path>

      <path
        d={
          "M480.6 341.2c-11.3 0-20.4 9.1-20.4 20.4V460H51.8v-98.4c0-11.3-9.1-20.4-20.4-20.4S11 350.4 11 361.6v118.8c0 11.3 9.1 20.4 20.4 20.4h449.2c11.3 0 20.4-9.1 20.4-20.4V361.6c0-11.2-9.1-20.4-20.4-20.4z"
        }
      ></path>
    </svg>
  );
}

export default UploadSvgrepoComsvgIcon;
/* prettier-ignore-end */
